import request from '@aned/request';

// 分页
export async function selectByPage(params) {
  return request('/api/static/cashing/rate/detailsOfWaybillDuration', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module:"basic"
  });
}

// 导出
export async function detailsOfWaybillDurationExport(params) {
  return request('/api/static/cashing/rate/detailsOfWaybillDurationExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module:"basic"
  });
}
